// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_RATING_OPTIONS = [
  {
    value: 1,
    text: 'Nightmare',
  },
  {
    value: 2,
    text: 'Bad',
  },
  {
    value: 3,
    text: 'Normal',
  },
  {
    value: 4,
    text: 'Good',
  },
  {
    value: 5,
    text: 'Perfect',
  },
];
